import React, { Suspense, useEffect, useState } from "react";
import { ClientOnly, useClient } from "shared/components/ClientOnly";

export const PopupContext = React.createContext()
export function usePopup() {
    // Не используем useClient() здесь - пусть компонент сам решает
    const [isOpenPopup, setIsOpenPopup] = useState(false);
    const [isOpenImagePopup, setIsOpenImagePopup] = useState(false);
    const [selectedCard, setSelectedCard] = useState({});
    const [selectedImage, setSelectedImage] = useState({});
    const [isReady, setIsReady] = useState(false);

    // Отслеживаем только клиентский рендер
    useEffect(() => {
        setIsReady(true);

        // Устанавливаем обработчики только на клиенте
        function handleEscape(evt) {
            if (evt.key === "Escape") {
                closePopup();
            }
        }

        function handleClosePopups(evt) {
            if (
                evt.target.classList.contains("popup_opened") ||
                evt.target.classList.contains("popup__close-icon")
            ) {
                closePopup();
            }
        }

        document.addEventListener("mousedown", handleClosePopups);
        document.addEventListener("keydown", handleEscape);

        return () => {
            document.removeEventListener("keydown", handleEscape);
            document.removeEventListener("mousedown", handleClosePopups);
        };
    }, []); // Пустой массив = только при монтировании

    // Эффект для body overflow
    useEffect(() => {
        if (isOpenPopup || isOpenImagePopup) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "visible";
        }
    }, [isOpenPopup, isOpenImagePopup]);

    function openImagePopup(image) {
        if (!isReady) {
            console.warn('Cannot open popup during SSR');
            return;
        }
        setIsOpenImagePopup(true);
        setSelectedImage(image);
        console.log('open image popup', image);
    }

    function openPopup(cardId) {
        if (!isReady) return;
        setIsOpenPopup(true);
        setSelectedCard(cardId);
    }

    function closePopup() {
        setIsOpenPopup(false);
        setIsOpenImagePopup(false);
    }


    return {
        isOpenPopup,
        isOpenImagePopup,
        selectedCard,
        selectedImage,
        openImagePopup,
        openPopup,
        closePopup,
        isPopupReady: isReady // Добавляем флаг готовности
    };
}
export const PopupProvider = ({ children }) => {
    const popup = usePopup()
    return <PopupContext.Provider value={popup}>
        {children}
    </PopupContext.Provider>
}